export const SET_DESTAJO = "SET_DESTAJO";
export const DELETE_DESTAJO = "DELETE_DESTAJO";
export const DESTAJOS_RECEIVED = "DESTAJOS_RECEIVED";
export const REORDENAR_DESTAJOS = "REORDENAR_DESTAJOS";
export const CREATE_NUEVO_DESTAJO = "CREATE_NUEVO_DESTAJO";
export const SET_PROPERTY_DESTAJO = "SET_PROPERTY_DESTAJO";
export const SET_PROPERTY_SINGLE_DESTAJO = "SET_PROPERTY_SINGLE_DESTAJO";
